
export default {
  name: 'EoColumns',
  props: {
    /**
     * Put columns that don't fit on a new line
     */
    multiline: {
      type: Boolean,
      default: false,
    },
    /**
     * Gaps between columns (0, 1, 2, 3, 4, 5, 6)
     */
    gap: {
      type: [String, Number, Object],
      default: '3',
    },
    /**
     * Horizontally center all columns
     */
    centeredX: {
      type: Boolean,
      default: false,
    },
    /**
     * Vertically center all columns
     */
    centeredY: {
      type: Boolean,
      default: false,
    },
    /**
     * Make contents of columns equal height
     */
    stretchedY: {
      type: Boolean,
      default: false,
    },
    /**
     * Take up all the space inside my parent
     */
    fluid: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes () {
      return {
        'eo-columns': true,
        'multiline': this.multiline,
        'centered-x': this.centeredX,
        'centered-y': this.centeredY,
        'stretched-y': this.stretchedY,
        'is-fluid': this.fluid,
      }
    },
    styles () {
      return {
        '--gap-xs': this.getGapProperty('xs'),
        '--gap-sm': this.getGapProperty('sm'),
        '--gap-md': this.getGapProperty('md'),
        '--gap-lg': this.getGapProperty('lg'),
        '--gap-xl': this.getGapProperty('xl'),
      }
    },
  },
  methods: {
    getGapProperty (breakpoint) {
      if (!this.gap) return
      let gapValue = ''
      if (typeof this.gap === 'object') {
        gapValue = this.$viewport.switch(this.gap, breakpoint)
      } else {
        gapValue = this.gap
      }
      return `var(--spacing-${gapValue})`
    },
  },
}
